/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-video.vue?vue&type=template&id=7891b736&scoped=true"
import script from "./pc-video.vue?vue&type=script&lang=js"
export * from "./pc-video.vue?vue&type=script&lang=js"
import style0 from "./pc-video.vue?vue&type=style&index=0&id=7891b736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891b736",
  null
  
)

export default component.exports